import React from "react";
import style from "./report.module.scss";
import Select from "react-dropdown-select";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useSelector } from "react-redux";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function Filter({ filter, setType, setDate, date ,loader}) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();

  const options = {
    Today: [moment().toDate(), moment().toDate()],
    "This Week": [moment().startOf("week"), moment().endOf("week").toDate()],
    "This Month": [
      moment().startOf("month").toDate(),
      moment().endOf("month").toDate(),
    ],
    "This Year": [
      moment().startOf("year").toDate(),
      moment().endOf("year").toDate(),
    ],
  };
  console.log("date ==== ", date);
  const { start, end, label } = date;
  const resetValue = () => {
    setDate((prev) => ({
      ...prev,
      start: moment().startOf("month"),
      end: moment(),
      label:
        moment().startOf("month").format("MMMM D, YYYY") +
        " - " +
        moment().format("MMMM D, YYYY"),
    }));
  };
  const handleCallback = (start, end) => {
    setDate((prev) => ({
      ...prev,
      start: start,
      end: end,
      label: start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY"),
    }));
  };
  return (
    <>
      {/* {start && end && ( */}
      {/* <DateRangePicker
          initialSettings={{
            startDate: start.toDate(),
            endDate: end.toDate(),
            ranges: options,
          }}
          onCallback={handleCallback}
        >  
        <div className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_DateRangePicker}`
            : `${style.DateRangePicker}`
        }`}>
        <i className="fa fa-calendar"></i>&nbsp;
        <span>{label}</span> <i className="fa fa-caret-down"></i>
      </div>
      </DateRangePicker> */}
      <div className={style.filterSection}>
        <DateRangePicker
          initialSettings={{
            startDate: start.toDate(),
            endDate: end.toDate(),
            ranges: options,
          }}
          onCallback={handleCallback}
        >
          <div
            className={`${
              currentTheme == "theme-dark"
                ? `${style.dark_mode_DateRangePicker}`
                : `${style.DateRangePicker}`
            }`}
          >
            <i className="fa fa-calendar"></i>&nbsp;
            <span>{label}</span> <i className="fa fa-caret-down"></i>
          </div>
        </DateRangePicker>

        {/* )} */}
        {/* <div className={style.filterContainer}>
    
        <Select
          options={filter}
          onChange={(values) => setType(values[0].value)}
          style={{
            width: "200px",
            backgroundColor: "white",
            borderRadius: "5px",
          }}
          placeholder="select type"
        />
      </div> */}
        <div className={style.filterButton}>
          {/* <Button
          variant="info"
          className={style.padding5}
          onClick={submitHandler}
          disabled={loader}
        >
          {loader ? (
            <i
              className="fa fa-refresh fa-spin"
              style={{ marginRight: "5px" }}
            />
          ) : (
            ""
          )}

          {t("Button.search")}
        </Button> */}
          <Button
            className={style.padding5}
            onClick={resetValue}
            disabled={loader}
          >
            {t("Button.reset")}
          </Button>
        </div>
      </div>
    </>
  );
}
